<template>
  <div class="home-page">
    <div class="home-content">
      <a-card class="home-company-card" title="">
        <div class="home-company-card-style">
          <div class="home-company-border-left">
            <img class="home-header-image" src="../../../public/static/icon/icon.png">
            <div class="home-company-info">
              <div class="home-company-name">
                {{userInfo?.COMPANY_NAME}}
              </div>
              <div class="home-company-member-border">
                <div class="home-company-member-style">
                  {{ $t('regularMembers') }}</div>
<!--                <div class="home-company-member-operate">
                  {{ $t('editInfo') }} <a-icon type="right" /></div>-->
              </div>
            </div>
          </div>

          <div class="home-company-border-right">
            <div class="home-company-statistics">
              <div class="home-company-statistics-title">本月订单数</div>
              <div class="home-company-statistics-number">56</div>
            </div>
            <a-divider style="height: 40px" type="vertical" />
            <div class="home-company-statistics">
              <div class="home-company-statistics-title">本月订单数</div>
              <div class="home-company-statistics-number">56</div>
            </div>
            <a-divider style="height: 40px" type="vertical" />
            <div class="home-company-statistics">
              <div class="home-company-statistics-title">本月订单数</div>
              <div class="home-company-statistics-number">56</div>
            </div>
          </div>
        </div>
      </a-card>

      <div class="home-info-border">
        <div class="home-info-left">
          <a-card title="我的代办">
            <div class="home-info-agency">
              <div class="home-info-agency-content">
                <img src="../../../public/static/icon/icon.png">
                <div style="margin: 12px 0;">待确认报价</div>
                <div>2</div>
              </div>
              <div class="home-info-agency-content">
                <img src="../../../public/static/icon/icon.png">
                <div style="margin: 12px 0;">{{ $t('waitReturnBox') }}</div>
                <div>2</div>
              </div>
            </div>
          </a-card>
          <a-card class="home-info-take-card">
            <template slot="title">
              <div class="home-info-take-title">
                <div>{{ $t('mySubscription') }}</div>
                <div @click="$router.push('/order/subscribe')" class="home-info-take-title_right">{{ $t('viewAll') }}<a-icon type="right" /></div>
              </div>
            </template>
            <div>
              <div class="home-info-take-content" v-for="item in subscribeList" :key="item">
                <div>
                  <div class="home-info-take-content-city">{{ $dt(item,'CITY_NAME') }}<a-icon style="margin:0 4px;color: #999999;" type="swap-right" />{{ $dt(item,'D_CITY_NAME') }}</div>
                  <div style="color: #999999; ">【{{ $t('single') }}】 {{ $dt(item,'BOX_SIZE_NAME') }} x {{ item.REAL_QTY }}</div>
                </div>
                <div class="home-info-take-content-price"><span style="font-size: 16px">${{ item.VALID_PRICE }}</span>/{{ $t('box') }}</div>
                <div>
                  <a-space>
                    <a-button class="home-info-take-content-button" @click="cancelSubscribe(item.MASTER_ID)">{{ $t('unsubscribe') }}</a-button>
                    <a-button @click="gotoApply(item)" type="primary">{{ $t('applyToBox') }}</a-button>
                  </a-space>
                </div>
              </div>
            </div>
          </a-card>
        </div>
        <div class="home-info-right">
          <a-card class="home-info-right-card">
            <template slot="title">
              <div class="home-info-right-title">
                <div>{{ $t('news') }}</div>
                <div class="home-info-right-title_right">{{ $t('viewAll') }}<a-icon type="right" /></div>
              </div>
            </template>
            <div>
              <div class="home-info-right-content" v-for="item in newList">
                <a-badge color="#1F6CBA" :text="item.content" />
                <div>{{ item.date }}</div>
              </div>
            </div>
          </a-card>
          <a-card class="home-info-right-card" style="margin-top: 12px;">
            <template slot="title">
              <div class="home-info-right-title">
                <div>{{ $t('notifications') }}</div>
                <div class="home-info-right-title_right">{{ $t('viewAll') }}<a-icon type="right" /></div>
              </div>
            </template>
            <div class="home-info-right-content" v-for="item in newList">
              <a-badge color="#1F6CBA" :text="item.content" />
            </div>
          </a-card>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import IndexHeader from "../../components/common/index-header";
import HomeMenu from "../../components/common/home-menu";
export default {
  name: "home",
  components: {HomeMenu, IndexHeader},
  data(){
    return{
      newList: [{
        content: '天津港口最新动态',
        date: '07-20',
      },{
        content: '天津港口最新动态',
        date: '07-20',
      },{
        content: '天津港口最新动态',
        date: '07-20',
      },{
        content: '天津港口最新动态',
        date: '07-20',
      },{
        content: '天津港口最新动态',
        date: '07-20',
      },{
        content: '天津港口最新动态',
        date: '07-20',
      }],
      subscribeList:[]
    }
  },
  computed:{
    userInfo(){
      return this.$store?.state?.userInfo;
    }
  },
  methods:{
    getSubscribe(){
      this.$h5Api({
        type: '4001',
        data: [{
          "QUERY_TYPE":0,
          "COMPANY_ID":this.userInfo.COMPANY_ID,
          "CITY_ID":'',
          "D_CITY_ID":'',
          "BOX_SIZE":''
        }],
        showMessage: false,
      }).then(({data}) => {
        this.subscribeList = data.OT_SUBSC_MASTER
      })
    },
    cancelSubscribe(id){
      this.$h5Api({
        type: '4003',
        data: [{
          "MASTER_ID":id,
          "DELETE_DESC":''
        }],
        showMessage: false,
      }).then(data => {
        this.$message.info(this.$t('operateSuccessfully'))
        this.query()
        this.editVisible = false
      })
    },
    gotoApply(data){
      this.$router.push({
        name:'boxApplyForm',
        query:{data}
      })
    },
  },
  created() {
    this.getSubscribe()
  }
}
</script>

<style lang="scss">
  .home-page{
    .home-content{
      .home-company-card{
        .home-company-card-style{
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .home-company-border-left{
            display: flex;align-items: center;

            .home-header-image{
              width: 60px;height: 60px;margin-right: 20px;
            }

            .home-company-info{
              display: flex;flex-direction: column;justify-content: space-between;height: 60px;

              .home-company-name{
                font-size: 20px;font-weight: 400;color: rgba(0,0,0,0.8500);line-height: 22px;
              }
              .home-company-member-border{
                display: flex;align-items: center;
                .home-company-member-style{
                  background: #FFFFFF;border-radius: 12px;border: 1px solid #1F6CBA;
                  padding: 1px 4px;color: #1F6CBA;
                  font-size: 12px;
                  cursor: pointer;
                }
                .home-company-member-operate{
                  font-size: 14px;font-weight: 400;color: #999999;line-height: 20px;margin-left: 32px;
                  cursor: pointer;
                }
              }
            }
          }

          .home-company-border-right{
            display: flex;
            align-items: center;
            text-align: right;
            .home-company-statistics{
              padding: 8px 32px;
              .home-company-statistics-title{
                font-size: 14px;
                font-weight: 400;
                color: rgba(0,0,0,0.4500);
                line-height: 22px;
              }
              .home-company-statistics-number{
                font-size: 30px;
                color: rgba(0,0,0,0.8500);
                line-height: 38px;
              }
            }
          }
        }

      }

      .home-info-border{
        display: flex;

        .home-info-left{
          flex: 1;margin: 12px 12px 12px 0;

          .home-info-agency{
            display: flex;

            .home-info-agency-content{
              text-align: left;padding: 20px 24px;border: 1px solid #eeeeee;
              width: 147px;cursor: pointer;
              img{
                width: 36px;border-radius: 50%;height: 36px;background: rgba(31,108,186,0.1000);
              }
            }
          }

          .home-info-take-card{
            margin-top: 12px;

            .home-info-take-title{
              display: flex;justify-content: space-between;

              .home-info-take-title_right{
                font-size: 12px;display: flex;align-items: center;
                font-weight: 400;
                cursor: pointer;
                color: #999999;
                line-height: 17px;
              }
            }

            .home-info-take-content{
              display: flex;justify-content: space-between;align-items: center;
              background: #F6F8FB;
              border-radius: 4px;
              padding: 13px 24px;
              margin: 10px 0;
              .home-info-take-content-city{
                font-size: 16px;
                color: #333333;
              }
              .home-info-take-content-price{
                font-size: 12px;
                color: #FF3D27;
              }
              .home-info-take-content-button{
                border: 1px solid #DDDDDD;
                background: #F6F8FB;
              }
            }
          }
        }
        .home-info-right{
          width: 300px;margin-top: 12px;

          .home-info-right-title{
            display: flex;justify-content: space-between;

            .home-info-right-title_right{
              font-size: 12px;display: flex;align-items: center;
              font-weight: 400;
              color: #999999;
              line-height: 17px;
              cursor: pointer;
            }
          }
          .home-info-right-content{
            display: flex;justify-content: space-between;
            padding: 9px 0;
            cursor: pointer;
          }
        }
      }
    }
  }
</style>